// geoBoundariesから行政界を安全に取得するためのエージェント向け手順。
export const GEOBOUNDARIES_SKILL = `## スキル: geoBoundaries行政界データ

手元に必要な行政界レイヤーがない場合はgeoBoundariesから取得できる。

1. 国をISO 3166-1 alpha-3コード（日本ならJPN）に変換する。
2. **get_boundary_info** で利用可能な行政レベル、件数、ライセンスを確認する。
3. ユーザーの目的に合うレベルを **fetch_boundaries** で取得する。
   ADM0は国境、ADM1は州・都道府県、ADM2は市郡相当。国により実際の区分は異なる。
4. 通常は軽量な simplified を使う。fullは詳細形状が明確に必要な場合だけ使用する。
5. 取得後は **describe_layer** で実在する属性列を確認してからSQLや塗り分けを行う。

最終回答にはgeoBoundariesをデータ源として使用したことと、ツール結果に含まれるライセンスを明記する。`
